package game.shader;


class TvStaticShader extends h3d.shader.ScreenShader {
	static var SRC = {
		@param var texture : Sampler2D;

		// Number of noise cells across the filtered image.
		@param var columns : Float;
		@param var rows : Float;

		// Integer-valued seed, advanced by the Haxe wrapper.
		@param var noiseFrame : Float;

		// 0 = original image, 1 = completely replaced by static.
		@param var amount : Float;

		// Brightness range of the generated static.
		@param var blackLevel : Float;
		@param var whiteLevel : Float;

		function fragment() {
			var source = texture.get(calculatedUV);

var cell = floor(calculatedUV * vec2(columns, rows));

// Hash (cell X, cell Y, frame) together instead of translating
// a fixed 2D noise field.
//
// Adapted from David Hoskins' "Hash without Sine", hash13.
var p = fract(vec3(cell.x, cell.y, noiseFrame) * 0.1031);
var scramble = dot(p, p.zyx + vec3(31.32));
p += vec3(scramble);

var noise = fract((p.x + p.y) * p.z);

			var luminance = mix(blackLevel, whiteLevel, noise);

			// Preserve the sprite's alpha and keep the generated
			// color premultiplied, including around transparent edges.
			var staticColor = vec3(luminance) * source.a;

			pixelColor = vec4(
				mix(source.rgb, staticColor, amount),
				source.a
			);
		}
	};
}


class TVFuzzFilter extends h2d.filter.Shader<TvStaticShader> {
	/** Noise refresh rate. Set to 0 to freeze the pattern. */
	public var noiseFPS : Float = 30.0;

	var accumulator : Float = 0.0;
	var frame : Int = 0;

	public function new(
		columns : Float = 256.0,
		rows : Float = 192.0,
		amount : Float = 1.0
	) {
		super(new TvStaticShader());

		setGrid(columns, rows);
		setAmount(amount);

		shader.noiseFrame = 0.0;
		shader.blackLevel = 0.0;
		shader.whiteLevel = 1.0;
	}

	/** Call once per game update; dt is in seconds. */
	public function update(dt : Float) : Void {
		if (noiseFPS <= 0.0 || dt <= 0.0)
			return;

		accumulator += dt * noiseFPS;

		var steps = Std.int(Math.floor(accumulator));
		if (steps == 0)
			return;

		accumulator -= steps;

		// Keep shader inputs bounded during long-running sessions.
		frame = (frame + steps) % 128;
		shader.noiseFrame = frame;
	}

	public function setGrid(columns : Float, rows : Float) : Void {
		shader.columns = Math.max(1.0, columns);
		shader.rows = Math.max(1.0, rows);
	}

	public function setAmount(value : Float) : Void {
		shader.amount = Math.max(0.0, Math.min(1.0, value));
	}
}